export class EpsAssignedChargeTypeDB {
  vehicle_spottype_reservationtype_id: number;
  vehicle_type_id: number;
  spot_type_id: number;
  reservation_type_id: number;
  charge_type: string;
}
